module.exports = __webpack_public_path__ + "img/dingdanchaxun.737fc7c7.svg";